"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHController = exports.KHGenericController = exports.KHInputType = exports.KHInputStatus = exports.KHAxisStatus = void 0;
var KHAxisStatus;
(function (KHAxisStatus) {
    KHAxisStatus[KHAxisStatus["Value"] = 0] = "Value";
    KHAxisStatus[KHAxisStatus["Changed"] = 1] = "Changed";
})(KHAxisStatus || (exports.KHAxisStatus = KHAxisStatus = {}));
var KHInputStatus;
(function (KHInputStatus) {
    KHInputStatus[KHInputStatus["JustDown"] = 0] = "JustDown";
    KHInputStatus[KHInputStatus["Down"] = 1] = "Down";
})(KHInputStatus || (exports.KHInputStatus = KHInputStatus = {}));
var KHInputType;
(function (KHInputType) {
    KHInputType[KHInputType["Key"] = 0] = "Key";
    KHInputType[KHInputType["Axis"] = 1] = "Axis";
})(KHInputType || (exports.KHInputType = KHInputType = {}));
class KHGenericController {
    constructor(inputMap, axisMap, inputSet) {
        this.inputs = new Map(inputMap);
        this.axes = new Map(axisMap);
        this.inputSet = inputSet;
    }
    register(registrar) {
        this.registered = registrar != null;
        this.inputSet.registerWith(registrar);
    }
    unregister() {
        this.registered = false;
        this.inputSet.unregister();
    }
    getStatus() {
        if (!this.inputSet.registered()) {
            console.warn("Attempting to get inputs with unregistered input set. Call register first.");
        }
        let inputs = new Map();
        this.inputs.forEach((value, key) => {
            inputs.set(key, [value.isJustDown(), value.isDown()]);
        });
        let axes = new Map();
        this.axes.forEach((value, key) => {
            axes.set(key, [value.getValue(), value.changed()]);
        });
        return [inputs, axes];
    }
    unregisterAllCallbacks(obj) {
        for (let key of this.inputs.values()) {
            key.unregisterAllCallbacksForObject(obj);
        }
        for (let axis of this.axes.values()) {
            axis.unregisterAllCallbacksForObject(obj);
        }
    }
    getInput(input) {
        if (this.inputs.has(input)) {
            return this.inputs.get(input);
        }
        return null;
    }
    isDown(input) {
        var _a;
        return (_a = this.getInput(input)) === null || _a === void 0 ? void 0 : _a.isDown();
    }
    isJustDown(input) {
        var _a;
        return (_a = this.getInput(input)) === null || _a === void 0 ? void 0 : _a.isJustDown();
    }
    getAxis(axis) {
        if (this.axes.has(axis)) {
            return this.axes.get(axis);
        }
        return null;
    }
    getIsAxisUpdated(axis) {
        if (!this.axes.has(axis)) {
            return false;
        }
        let input = this.axes.get(axis);
        return input.getValue() != input.getLastValue();
    }
    /**
     * Injects a new input for an existing one. Useful if you want to use a
     * resettable key, for instance.
     * @param input
     * @param newInput
     */
    inject(input, newInput) {
        this.inputs.set(input, newInput);
    }
}
exports.KHGenericController = KHGenericController;
class KHController extends KHGenericController {
}
exports.KHController = KHController;
